/**
 * Definitions of all OIDC "request scopes" that should be trackable.
 */
export enum OIDCRequestScopes {
  LoadOIDCProviders = "oidc_fetch_providers",
  FetchOIDCToken = "oidc_load_token",
  LoginWithOIDCToken = "oidc_login_with_token"
}
